import { useSelector } from 'react-redux';

import { AppState } from 'state/types';

import {
  selectIsReadonlyDueToMonitoring,
  selectIsReadonlyDueToStorage,
  selectIsReadonlyDueToTrial,
  selectShowMemberMonitoringBanner,
  selectShowMemberStorageBanner,
  selectShowMemberTrialBanner,
} from './selectors';

export function useMemberBannersVisibility(organizationName: string) {
  const showTrialBanner = useSelector((state: AppState) =>
    selectShowMemberTrialBanner(state, organizationName),
  );
  const showMonitoringBanner = useSelector((state: AppState) =>
    selectShowMemberMonitoringBanner(state, organizationName),
  );
  const showStorageBanner = useSelector((state: AppState) =>
    selectShowMemberStorageBanner(state, organizationName),
  );

  const isReadonlyDueToTrial = useSelector((state: AppState) =>
    selectIsReadonlyDueToTrial(state, organizationName),
  );
  const isReadonlyDueToMonitoring = useSelector((state: AppState) =>
    selectIsReadonlyDueToMonitoring(state, organizationName),
  );
  const isReadonlyDueToStorage = useSelector((state: AppState) =>
    selectIsReadonlyDueToStorage(state, organizationName),
  );

  return {
    showMemberTrialErrorBanner: isReadonlyDueToTrial && showTrialBanner,
    showMemberCardErrorBanner: false,
    showMemberPaymentErrorBanner: undefined,
    showMemberMonitoringErrorBanner: isReadonlyDueToMonitoring && showMonitoringBanner,
    showMemberStorageErrorBanner: isReadonlyDueToStorage && showStorageBanner,
    showMemberTrialWarnBanner: !isReadonlyDueToTrial && showTrialBanner,
    showMemberCardWarnBanner: false,
    showMemberPaymentWarnBanner: undefined,
    showMemberMonitoringWarnBanner: !isReadonlyDueToMonitoring && showMonitoringBanner,
    showMemberStorageWarnBanner: !isReadonlyDueToStorage && showStorageBanner,
  };
}
